import { useQuery } from '@tanstack/react-query';
import { api } from '../../../singleton/axios';

interface SenateLatest {
  symbol: string;
  disclosureDate: string;
  transactionDate: string;
  firstName: string;
  lastName: string;
  office: string;
  district: string;
  owner: string;
  assetDescription: string;
  assetType: string;
  type: string;
  amount: string;
  comment: string;
  link: string;
}

interface SenateLatestResponse {
  data: SenateLatest[];
  pagination: {
    page: number;
    limit: number;
    count: number;
    hasNextPage: boolean;
  };
}

interface UseSenateLatestParams {
  page?: number;
  limit?: number;
  enabled?: boolean;
}

export const useSenateLatest = ({ page = 0, limit = 100, enabled = true }: UseSenateLatestParams = {}) => {
  return useQuery({
    queryKey: ['senate-latest', page, limit],
    queryFn: async (): Promise<SenateLatestResponse> => {
      const response = await api.get('/senate-latest', {
        params: { page, limit },
      });
      return response.data;
    },
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes - fresher data for better UX
    refetchOnWindowFocus: false,
  });
};

export type { SenateLatest, SenateLatestResponse };